import AvailabilityRestriction from '@/models/Workers/AvailabilityRestriction';

export default class AvailabilityRestrictionViewModel {
    name: string;
    value: AvailabilityRestriction;

    public constructor(name: string, value: AvailabilityRestriction) {
        this.name = name;
        this.value = value;
    }
}